import { EMBEDDER_TO_CLIENT_WEB_INITIAL_PROPS_PROP_NAME, IClientWebEmbeddingInitialProps } from '@youhelp-ru/common/clientWebEmbedding';
import { authenticationSlice } from '@cp/shared/api/core';
import { introSlice } from '@cp/entities/intro';
import { embeddingSlice } from 'src/shared/embedding';
import { StoreType } from '../../../redux';

export const initializeEmbedding = (parameters: { store: StoreType }) => {
  const initialPropsString = typeof window !== 'undefined' && window.ReactNativeWebView?.injectedObjectJson?.();
  let initialProps: IClientWebEmbeddingInitialProps | undefined = window[EMBEDDER_TO_CLIENT_WEB_INITIAL_PROPS_PROP_NAME];

  if (!initialProps) {
    try {
      initialProps = JSON.parse(initialPropsString);
    } catch {}
  }

  if (!initialProps) {
    return;
  }

  const { store } = parameters;

  store.dispatch(embeddingSlice.actions.updateSharedState(initialProps.sharedState));

  if (initialProps.authToken) {
    store.dispatch(authenticationSlice.actions.setToken(initialProps.authToken));
  }
  if (initialProps.introCatalogType) {
    store.dispatch(introSlice.actions.setCatalogType(initialProps.introCatalogType));
  }
  if (initialProps.introCareerId) {
    store.dispatch(introSlice.actions.setCareerId(initialProps.introCareerId));
  }
};
